<template lang="pug">	
	.easy-creative--integration
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions') + '..'", :fullscreen="true")
</template>

<script>
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-results',
		props: ['apiKey', 'email', 'userName', 'answers', 'mode'],
		components: {
			Loader
		},
		data() {
			return {
				isLoading: 0,
				settings: null
			};
		},
		computed: {
			integrationInfo() {
				return {
					email: this.email,
					userName: this.userName,
					answers: this.answers,
					mode: this.mode,
					integrationId: this.apiKey,
					settings: this.settings
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeIntegration = this;
			this.isLoading++;
			this.getToken().then(async r => {
				await this.$auth.setAuthenticated(r);
				await this.loadIntegrationSettings();
				this.$router.push({ name: 'easy-creative', params: { 
					briefId: this.settings?.Brief?.Oid,
					apiKey: this.settings?.Branding?.Oid,
					integrationInfo: this.integrationInfo
				}});
			}).finally(() => this.isLoading--);
			
		},
		methods: {
			async getToken() {
				this.isLoading++;
				return this.$Data.getExternalApi('BriefIntegrationSetting/GenerateToken', `integrationId=${this.apiKey}&email=${this.email}`).finally(() => this.isLoading--);
			},
			async loadIntegrationSettings() {
				this.isLoading++;
				this.settings = (await this.$Data.getExternalApi('BriefIntegrationSetting/Get', `id=${this.apiKey}`).finally(() => this.isLoading--));
			}
		}
	};
</script>
<style lang='scss'>
	.easy-creative--integration {

	}
</style>
